import React, {useEffect, useRef, useState} from 'react';

export function InputDropdown({name, value, options, className = '', placeholder = '', handleSelected}) {
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [list, setList] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const refInput = useRef(null);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleFocus = () => {
    setVisible(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (refInput && refInput.current && refInput.current !== document.activeElement) {
        setVisible(false);
      }
    }, 200);
  };

  const handleClick = (item) => {
    handleSelected(item);
    setSearch('');
    refInput.current.focus();
  };

  useEffect(() => {
    setList((options || []).filter(i => !value || value.length === 0 || value.indexOf(i) < 0));
  }, [value, options]);

  useEffect(() => {
    setLoading(true);
    if (!search.trim()) {
      setFiltered(list);
    } else {
      setFiltered(list.filter(i => i.toLowerCase().indexOf(search.trim().toLowerCase()) > -1));
    }
    setLoading(false);
  }, [search, list]);

  return <div className="dropdown__group">
    <input type="text"
           ref={refInput}
           className={"input" + (className ? " " + className : "")}
           placeholder={placeholder}
           name={name}
           value={search}
           onFocus={handleFocus}
           onBlur={handleBlur}
           onChange={handleChange}/>
    {visible && <ul className="dropdown">
      {
        filtered.map((i, k) => <li key={k} className="dropdown__item">
            <span onClick={() => handleClick(i)}>{i}</span>
          </li>
        )
      }
      {!loading && filtered.length === 0 && search !== '' && <li className="dropdown__item">
        <span onClick={() => handleClick(search)}>Добавить {search}</span>
      </li>}
    </ul>}
  </div>;
}
